import { Injector } from '@angular/core';

export let globalInjector: Injector;

export function setGlobalInjector(injector: Injector): void {
    if (globalInjector) {
        console.error('globalInjector was already set');
    } else {
        globalInjector = injector;
    }
}
